$(document).ready(function($) {

    var work_experience = $(".work_experience_content");


    work_experience.each(function( index ) {
        var work_start_year = $(this).find(".start_year");
        var work_end_year = $(this).find(".end_year");

        var work_start_month = $(this).find(".start_month");
        var work_end_month = $(this).find(".end_month");

        checkWorkMonts(work_start_month, work_start_year, work_end_month, work_end_year);

        work_start_year.on("change", function () {
            var values = work_end_year.find("option");

            values.each(function (i) {
                if($(this).val() < work_start_year.val()){
                    $(this).addClass('hide');
                    $(this).removeAttr("selected");
                }else{
                    $(this).removeClass('hide');
                }
            });

            checkWorkMonts(work_start_month, work_start_year, work_end_month, work_end_year);
        });


        work_start_month.on("change", function () {
            checkWorkMonts(work_start_month, work_start_year, work_end_month, work_end_year);
        });


        work_end_year.on("change", function () {
            checkWorkMonts(work_start_month, work_start_year, work_end_month, work_end_year);
        });
    });




    function checkWorkMonts(work_start_month, work_start_year, work_end_month, work_end_year) {
        var values = work_end_month.find("option");


        if(work_start_year.val() == work_end_year.val()){
            values.each(function (i) {
                if(parseInt($(this).val()) < parseInt(work_start_month.val())){
                    $(this).addClass('hide');
                    $(this).removeAttr("selected");
                }else{
                    $(this).removeClass('hide');
                }
            })
        }else{
            values.each(function (i) {
                $(this).removeClass('hide');
            })
        }
    }

    function checkMonts(start_month, start_year, end_month, end_year) {

        var values = end_month.find("option");


        if(start_year.val() == end_year.val()){
            values.each(function (i) {
                if(parseInt($(this).val()) < parseInt(start_month.val())){
                    $(this).addClass('hide');
                    $(this).removeAttr("selected");
                }else{
                    $(this).removeClass('hide');
                }
            })
        }else{
            values.each(function (i) {
                $(this).removeClass('hide');
            })
        }
    }


    $(".edit-experience").each(function (i) {
        var start_year = $(this).find(".start_year");
        var end_year =  $(this).find(".end_year");

        var start_month =  $(this).find(".start_month");
        var end_month =  $(this).find(".end_month");

        var values = end_year.find("option");

        values.each(function (i) {
            if($(this).val() < start_year.val()){
                $(this).addClass('hide');
            }
        });

        start_year.on("change", function () {
            var values = end_year.find("option");

            values.each(function (i) {
                if($(this).val() < start_year.val()){
                    $(this).addClass('hide');
                    $(this).removeAttr("selected");
                }else{
                    $(this).removeClass('hide');
                }
            });
            checkWorkMonts(start_month, start_year, end_month, end_year);
        });


        start_month.on("change", function () {
            checkWorkMonts(start_month, start_year, end_month, end_year);
        });


        end_year.on("change", function () {
            checkWorkMonts(start_month, start_year, end_month, end_year);
        });
    });


    
    $(".edit-education").each(function (i) {
        var start_year = $(this).find(".start_year");
        var end_year =  $(this).find(".end_year");

        var start_month =  $(this).find(".start_month");
        var end_month =  $(this).find(".end_month");

        var values = end_year.find("option");
        
        values.each(function (i) {
            if($(this).val() < start_year.val()){
                $(this).addClass('hide');
            }
        });

        checkMonts(start_month, start_year, end_month, end_year);


        start_year.on("change", function () {
            var values = end_year.find("option");

            values.each(function (i) {
                if($(this).val() < start_year.val()){
                    $(this).addClass('hide');
                    $(this).removeAttr("selected");
                }else{
                    $(this).removeClass('hide');
                }
            });
            checkMonts(start_month, start_year, end_month, end_year);
        });



        start_month.on("change", function () {
            checkMonts(start_month, start_year, end_month, end_year);
        });


        end_year.on("change", function () {
            checkMonts(start_month, start_year, end_month, end_year);
        });
    });



    var education = $(".education_content");



    // var start_year = education.find(".start_year");
    // var end_year = education.find(".end_year");
    //
    // var start_month = education.find(".start_month");
    // var end_month = education.find(".end_month");
    //
    // checkMonts();
    //
    // start_year.on("change", function () {
    //     var values = end_year.find("option");
    //
    //     values.each(function (i) {
    //         if($(this).val() < start_year.val()){
    //             $(this).addClass('hide');
    //             $(this).removeAttr("selected");
    //         }else{
    //             $(this).removeClass('hide');
    //         }
    //     });
    //
    //     checkMonts();
    // });
    //
    //
    // start_month.on("change", function () {
    //     checkMonts();
    // });
    //
    //
    // end_year.on("change", function () {
    //     checkMonts();
    // });

    education.each(function( index ) {
        var start_year = $(this).find(".start_year");
        var end_year = $(this).find(".end_year");

        var start_month = $(this).find(".start_month");
        var end_month = $(this).find(".end_month");

        checkMonts(start_month, start_year, end_month, end_year);

        start_year.on("change", function () {
            var values = end_year.find("option");

            values.each(function (i) {
                if($(this).val() < start_year.val()){
                    $(this).addClass('hide');
                    $(this).removeAttr("selected");
                }else{
                    $(this).removeClass('hide');
                }
            });

            checkMonts(start_month, start_year, end_month, end_year);
        });


        start_month.on("change", function () {
            checkMonts(start_month, start_year, end_month, end_year);
        });


        end_year.on("change", function () {
            checkMonts(start_month, start_year, end_month, end_year);
        });
    });
});
